<template>
  <v-app id="inspire" class="background-svg" :style="backgroundStyle">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs11 sm6 md4>
            <v-card class="elevation-12 pb-10 px-4 pt-5" min-width="400">
              <v-card-title
                class="text-center d-flex flex-column justify-center"
              >
                <div class="justify-center">
                  <v-img
                    :src="API_BASE_URL + '/web_front/icon_logo.svg'"
                    class="logo-svg"
                  ></v-img>
                </div>
                <br />
                <div>
                  <span>Login</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="user.email"
                    name="email"
                    label="Email"
                    outlined
                    dense
                    type="text"
                    v-validate="'required|email'"
                    :error="
                      errors.first('email') != null ||
                      serverSideErrors.email != null
                    "
                    :error-messages="
                      errors.first('email') || serverSideErrors.email
                    "
                  ></v-text-field>
                  <v-text-field
                    v-model="user.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    @click:append="showPassword = !showPassword"
                    id="password"
                    name="password"
                    outlined
                    dense
                    v-validate="'required'"
                    :error="
                      errors.first('password') != null ||
                      serverSideErrors.password != null
                    "
                    :error-messages="
                      errors.first('password') || serverSideErrors.password
                    "
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-row>
                <v-col cols="7">
                  <!-- <v-checkbox
                    v-model="remember"
                    label="Remember Me"
                    color="primary"
                    value="primary"
                    hide-details
                    class="ma-0 ml-3"
                  ></v-checkbox> -->
                </v-col>
                <v-col cols="5">
                  <router-link
                    to="/superadmin/forgotPassword"
                    class="text-decoration-none"
                  >
                    Forgot Password ?
                  </router-link>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-6">
                  <v-btn
                    block
                    color="primary"
                    @click="login"
                    :loading="loading"
                  >
                    Login
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-flex>
          <Alert />
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Alert from "../../Alert.vue";
import "@/assets/style.css";
import { mapMutations } from "vuex";
// const backgroundImageUrl = `${process.env.VUE_APP_API_URL}/web_front/bulding.svg`;
export default {
  components: {
    Alert,
  },
  data() {
    return {
      showPassword: false,
      user: {
        email: "",
        password: "",
      },
      remember: false,
      loading: false,
      serverSideErrors: {},
      
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${process.env.VUE_APP_API_URL}/web_front/bulding.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center' ,
        height: '100vh' ,
      };
    }
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),
    login() {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.remember) {
            localStorage.setItem("email", this.user.email);
          }

          _self.loading = true;

          _self.$axios.post("/superadmin/login", this.user).then((response) => {
            let data = response.data;
            _self.loading = false;

            if (data.status) {
                data.user.token = data.token;
              localStorage.setItem("user", JSON.stringify(data.user));
              this.$axios.defaults.headers.common = {
                Authorization: "Bearer " + data.user.token,
              };
              this.$vuetify.theme.themes.light.primary =
                data.user.primary_color;
              this.$vuetify.theme.themes.dark.primary = data.user.primary_color;
              this.$vuetify.theme.themes.light.secondary =
                data.user.button_color;
              this.$vuetify.theme.themes.dark.secondary =
                data.user.button_color;
              this.$router.push({ path: "/superadmin/dashboard" });
            } else {
              if (data.errors) {
                _self.serverSideErrors = {};
                
                for (let i = 0; i < data.errors.length; i++) {
                  _self.serverSideErrors[data.errors[i].field] =
                    data.errors[i].message;
                }
              } else {
                this.setAlert({
                  showAlert: true,
                  variant: "red accent-3",
                  timeout: "2000",
                  message: data.message,
                });
              }
            }
          });
          return;
        }
      });
    },
  },
  mounted() {
    let email = localStorage.getItem('email');
    if(email) { 
      this.user.email = email;
    }
  }
};
</script>

<style scoped>



.logo-svg {
  width: 150px !important;
}
</style>